/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: Explore
 *| (C) Copyright IBM Corp. 2018, 2020
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */

import React, { Component } from 'react';
import { observer } from 'mobx-react';
import PropTypes from 'util/PropTypes';
import {
	Tabs as BaseTabs
} from '@ba/ba-ui-carbon-toolkit';

import _ from 'underscore';

import StringResources from 'nls/StringResources';

const label = {
	'slots': 'slot_editor',
	'properties': 'propertiesPanelLabel',
	'details': 'exploreToolbar_details'
};

@observer
class Tabs extends Component {

	render() {
		const forwardedProps = _.omit(this.props, 'children', 'model');
		const selectedTab = this.props.model.getTab();

		const labelToUse = this._getLabelForSection(selectedTab);
		const header = StringResources.get(labelToUse);

		return (
			<div {...forwardedProps} onKeyDown={(e) => this.onKeyDown(e)} >
				<div className='explore__tabsHeader'> {header} </div>
				<BaseTabs
					selected={selectedTab}
					onChange={tabId => this.onTabChange(tabId)}
				>
					{this.props.children}
				</BaseTabs>
			</div>
		);
	}

	_getLabelForSection(selectedTab) {
		return label[selectedTab] || '';
	}

	onTabChange(id) {
		this.props.model.showTab(id);
	}

	onKeyDown(event = {}) {
		//Defect 279835: Using Delete key when tabbed above or below the slot deletes whole card
		const shouldHandle = event.key === 'Delete' || event.key === 'Backspace';

		if (shouldHandle){
			//This will be used in the keyDown handler in ExploreContainer
			event.handled = true;
		}
	}

}

Tabs.propTypes = {
	model: PropTypes.object.isRequired,
	children: PropTypes.any,
	onTabChange: PropTypes.func
};

Tabs.defaultProps = {
	children: [],
	onTabChange: () => {}
};

export default Tabs;



// WEBPACK FOOTER //
// ./src/js/components/tabs/Tabs.js